import React, { FC } from 'react';
import { FormFieldToggleButtonGroupProps } from '../../form/fields/FormFieldToggleButtonGroup';
import { FormikFormProps } from '../../form/FormikForm';
import { PictureProps } from '../../atoms/Picture';
import { Icons } from '../../atoms/Icon';
import { ToggleButtonVariant } from '../../atoms/ToggleButton/styled';
import { colors } from '../../../theme';
import ActionButton, { ActionButtonProps } from '../../atoms/ActionButton';
import { HtmlProps } from '../../atoms/Html';
import * as SC from './styled';
export type ArticleQuizProps = MinimalSeoBlock & {
  className?: string;
  imageProps: PictureProps;
  question?: string;
  answerTitle?: string;
  answerText?: HtmlProps;
  textEnd?: HtmlProps;
  currentQuestion?: number;
  count?: string;
  rightAnswer?: string;
  formikForm?: FormikFormProps;
  formFieldToggleButtonGroupProps?: FormFieldToggleButtonGroupProps;
  actionButtonProps?: ActionButtonProps;
  facebookButtonProps?: ActionButtonProps;
  twitterButtonProps?: ActionButtonProps;
};
const ArticleQuiz: FC<ArticleQuizProps> = ({
  className,
  htmlTag,
  imageProps,
  question,
  answerTitle,
  answerText,
  textEnd,
  currentQuestion,
  count,
  rightAnswer,
  formikForm,
  formFieldToggleButtonGroupProps,
  actionButtonProps,
  facebookButtonProps,
  twitterButtonProps
}) => {
  return <SC.Main className={className} as={htmlTag}>
      <SC.BackgroundImage {...imageProps} />
      <SC.Card>
        <SC.Bezel viewBox="0 0 335 11" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0 0.375V10.375H168.303C99.7883 10.3705 38.8536 6.45373 0 0.375ZM168.537 10.375H335V0.658797C296.078 6.57536 235.98 10.3706 168.537 10.375Z" />
        </SC.Bezel>
        <SC.Content>
          {currentQuestion && <SC.Pastille>{currentQuestion}</SC.Pastille>}
          {count && <SC.NumberOfQuestion>{count}</SC.NumberOfQuestion>}
          {question && <SC.Title>{question}</SC.Title>}
          {formikForm && <SC.Form {...formikForm}>
              {props => <>
                  {formFieldToggleButtonGroupProps && <SC.Button {...formFieldToggleButtonGroupProps} options={formFieldToggleButtonGroupProps.options.map(option => ({
              ...option,
              variant: ToggleButtonVariant.quiz,
              disabled: props.values.answer?.length > 0,
              colorChecked: rightAnswer !== option.value ? colors.ruby : undefined,
              onChange: () => {
                option?.onChange;
                props?.submitForm();
              },
              icon: props.values.answer?.length > 0 && props.values.answer?.includes(option.value) ? rightAnswer === option.value ? Icons.check : Icons.close : undefined
            }))} />}
                  {props.values.answer?.length > 0 && <>
                      <SC.AnswerTitle>{answerTitle}</SC.AnswerTitle>
                      {answerText && <SC.Text {...answerText} />}
                    </>}
                  {props.values.answer?.length > 0 && actionButtonProps && <ActionButton {...actionButtonProps}
            // should not be any here but fuck if I know what it is
            onClick={(e: any) => {
              actionButtonProps?.onClick?.(e);
              props?.resetForm({
                values: props.initialValues
              });
            }} />}
                </>}
            </SC.Form>}
          {textEnd && <SC.Text {...textEnd} />}
          {facebookButtonProps && twitterButtonProps && <SC.ActionButtonContainer>
              <ActionButton {...facebookButtonProps} />
              <ActionButton {...twitterButtonProps} />
            </SC.ActionButtonContainer>}
        </SC.Content>
      </SC.Card>
    </SC.Main>;
};
export default ArticleQuiz;